"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MonthButton: {
    background: 'white'
  },
  MonthArrowPrev: {
    borderRightColor: '#ddbec1',
    cursor: 'pointer'
  },
  MonthArrowNext: {
    borderLeftColor: '#ddbec1',
    cursor: 'pointer'
  },
  DaySelected: {
    background: '#f81861'
  },
  DayActive: {
    background: '#f81861',
    boxShadow: 'none'
  },
  DayInRange: {
    background: '#ddbec1',
    color: '#fff'
  },
  WeekDay: {
    fontWeight: 'normal'
  },
  DayHover: {
    background: '#ffffff',
    color: '#7f8c8d',
    transform: 'scale(1.1) translateY(-10%)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  DayPassive: {
    background: 'white',
    color: 'black'
  }
};
exports["default"] = _default;

//# sourceMappingURL=DatePickerStyle.js.map